import { parseBool } from "../../lib/calculations";
import { combineLatest, from } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import { toUpperCaseList } from "../../lib/caseOperations";
import { FormItem } from "@/cs-ts-bridge/ts/form-item";
import { BaseControlDefBase, BaseElementDef, BaseElementDefBase } from "./BaseElementDef";
import { FormDefinitionItem } from "./__DefinitionDataInterface";
import { DisplayIfOtherHasValueSettings } from "@cs-ts/display-if-other-has-value-settings";
import { CalculationContext } from "./__CalculationContextInterface";

export default class DisplayIfOtherHasValueDef extends BaseElementDef<DisplayIfOtherHasValueSettings, FormDefinitionItem<DisplayIfOtherHasValueSettings>, FormItem> {
    constructor(parentElement: BaseElementDefBase | null, elementData: FormItem, definitionData: FormDefinitionItem<DisplayIfOtherHasValueSettings>, calculationContext: CalculationContext) {
        super(parentElement, elementData, definitionData, calculationContext);
        this.typeName = "MI.Common.DynamicForms.Models.DFDisplayIfOtherHasValue"; // TODO - not hardcoded?
    }

    visible$() {
        return super.visible$().pipe(
            switchMap(v => {
                if (!v) return from([false]);
                else {
                    if (this.definition.settings.calculationId != null || (this.definition.settings.legacyCalculation || []).length > 0) {
                        const result = this.resolveCalculation(this.definition.settings.calculationId!, this.definition.settings.legacyCalculation);
                        return result.pipe(map(value => value.reduce((a, i) => a || parseBool(i) === 1, false)));
                    } else {
                        const matches = this.definition.settings.valuesToMatch ? this.definition.settings.valuesToMatch.slice() : [];
                        if (this.definition.settings.valueToMatch) {
                            matches.push(this.definition.settings.valueToMatch);
                        }
                        const upperCaseMatches = toUpperCaseList(matches);
                        const otherElementIsDirectDescendant = this.getElementsByFilter(element => element.id == this.definition.settings.otherElementId).length > 0;
                        if (otherElementIsDirectDescendant) {
                            return from([true]);
                        } else {
                            return this.calculationContext.rootElement!.getElementsById$(this.definition.settings.otherElementId!, this.vmId).pipe(
                                switchMap(children => combineLatest(children.map(i => (i as BaseControlDefBase).effectiveValueList$()))),
                                map(valueLists => Array.prototype.concat.apply([], valueLists)),
                                map(valueList => toUpperCaseList(valueList)),
                                map(upperValueList => (this.definition.settings.invert || false) != upperValueList.some(v => upperCaseMatches.some(m => v == m))),
                            );
                        }
                    }
                }
            }),
        );
    }

    valid$(includeUnedited?: boolean, excludeChildren?: boolean) {
        return combineLatest(this.visible$(), super.valid$(includeUnedited, excludeChildren)).pipe(map(([visible, valid]) => !visible || valid));
    }
}
